<template>
  <div>
    <b-card border-variant="danger" v-if="errore_caricamento">
      <b-row class="match-height">
        <b-col
          md="8"
        >
          <h4 class="mt-0 mb-0 text-danger">Errore durante il caricamento delle informazioni iniziali</h4>
          <p>Ti preghiamo di segnalare il problema all'assistenza tecnica, grazie</p>
        </b-col>
        <b-col 
          md="4"
          class="text-center"
        >
          <b-button
          variant="primary"
          :to="{ name: 'home-agentscout' }"
          >
              <feather-icon
                  icon="CornerUpLeftIcon"
                  size="16"
                  class="mr-1"
              />Home
          </b-button>
        </b-col>
      </b-row>
        
    </b-card>
        
    <div class="text-center my-3" v-if="Caricato == false">
      <b-spinner  v-if="errore_caricamento == false"
          variant="primary"
          style="width: 3rem; height: 3rem;"
          label="loading"
      />
      <div class="pt-1 text-primary" style="display:block;">Caricamento</div>
    </div>

    <b-card bg-variant="Default" v-if="Caricato">
      <!--
      <b-row class="match-height">
        <b-col
          md="11"
          cols="10" 
          class="mb-2"
        >
          
          <b-input-group>
            <b-input-group-prepend>
              <b-form-select style="border-top-right-radius:0px; border-bottom-right-radius:0px;" v-model="campiRicerca.sezione" :options="options_ricerca" disabled-field="notEnabled"></b-form-select>
            </b-input-group-prepend>
              <b-form-input v-model="campiRicerca.nome"
                  placeholder="ricerca generale"
                  type="text" />
            <b-input-group-append>
              <b-button variant="outline-primary" @click.prevent="ricercaGenerale">
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>

          </b-input-group>
        </b-col>
        <b-col
          md="1"
          cols="2"
          class="mb-2"
        >
          <b-button variant="outline-primary" class="px-0" @click.prevent="clickReset" block v-if="resetState != 'hidden'"><feather-icon icon="DeleteIcon" /></b-button>
        </b-col>
        
      </b-row>
      -->

        <div class="text-right">
          <b-button variant="outline-primary" class="px-1 mb-1" @click.prevent="clickReset" v-if="resetState != 'hidden'"><feather-icon icon="DeleteIcon" /></b-button>
        </div>

        <!-- table -->
        <vue-good-table
        mode="remote"
        ref="table"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading=isLoading
        :search-options="{ 
            enabled: true,
            externalQuery: searchTerm }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        >
        
        <template slot="loadingContent">
          <div class="text-center my-3">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem;"
                label="loading"
              />
              <div class="d-block pt-1 text-primary">Caricamento</div>
          </div>
        </template>
        
        <div slot="emptystate"> <div class="text-center py-4"> Nessun dato disponibile - (Messaggio personalizzabile) </div> </div>

        <template
            slot="table-row"
            slot-scope="props"
        >

            <!-- company_name -->
            <div v-if="props.column.field === 'license.customer.billing.company_name'">
            <a @click="$router.push({ name: 'crm-customers-show', params: { id_riga: props.row.license.customer.id }})">{{ props.row.license.customer.billing.company_name }}</a>   
            </div>

            <span v-else-if="props.column.field === 'license.type'">
              <b-badge :variant="statusVariantTipo(props.row.license.type)">
                  {{ props.row.license.type }}
              </b-badge>
            </span>

            <!-- Column: license.price -->
            <span v-else-if="props.column.field === 'license.price'">
              {{ prezzoFormattatoConIva(props.formattedRow[props.column.field], props.row.license.customer.billing.vat_scheme_id) }}
            </span>
            
            <!-- Column: paid -->
            <span v-else-if="props.column.field === 'paid'">
              <b-badge variant="light-success" v-if="(props.formattedRow[props.column.field] === true)">
                Pagato
              </b-badge>
              <b-badge variant="light-warning" v-else>In corso</b-badge>
            </span>
            
            <!-- Column: disputa.id -->
            <span v-else-if="props.column.field === 'dispute.id'">
              <span v-if="props.row.bonificidispute !== null">
                <b-badge variant="light-info">
                  Bonifico
                </b-badge>
              </span>
              <span v-else>
                <b-badge variant="light-danger" v-if="(props.formattedRow[props.column.field])">
                  Disputa
                </b-badge>
                <b-badge variant="light-success" v-else>Nessuna</b-badge>
              </span>
            </span>
            
            <!-- Column: refund -->
            <span v-else-if="props.column.field === 'refund'">
              <span v-if="(props.formattedRow[props.column.field])">
                <b-badge :variant="getBadgeStatoRimborso(props.row.refund)">
                  {{ statoRimborso(props.row.refund) }}
                </b-badge>
              </span>
              <span v-else>
                -
              </span>
            </span>

            <!-- Column: created_at -->
            <div v-else-if="props.column.field === 'created_at'">
              {{ formattazioneDataOra(props.row.created_at, 'it', 'DD/MM/YY') }}
            </div>

            <!-- Column: updated_at -->
            <div v-else-if="props.column.field === 'updated_at'">
              {{ formattazioneDataOra(props.row.updated_at, 'it', 'DD/MM/YY') }}
            </div>

            <!-- Column: azioni -->
            <span v-else-if="props.column.field === 'azioni'">
              <div class="text-nowrap">
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="cursor-pointer text-secondary"
                  v-b-tooltip.hover.v-primary
                  title="Azioni"
                  :id="`tabellautenti-riga-${props.row.id}-sidebar-azioni`"
                  @click="sidebarAction(props.row.id, props.row.license, props.row.api_invoice, props.row.api_payment_intent, props.row.paid, props.row.refund, props.row.created_at, props.row.updated_at, props.row.license.customer.billing.company_name, props.row.dispute, props.row.bonificidispute)"
                />
              </div>
            </span>

            <!-- Column: standard -->
            <span v-else>
            {{ props.formattedRow[props.column.field] }}
            </span>
        </template>

        <!-- pagination -->
        <template
            slot="pagination-bottom"
            slot-scope="props"
        >
            <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                Visualizzazione da 1 a 
                </span>
                <b-form-select
                v-model="pageLength"
                :options="['10','25','50','100']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap "> di {{ props.total }} righe </span>
            </div>
            <div>
                <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
                >
                <template #prev-text>
                    <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                    />
                </template>
                <template #next-text>
                    <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                    />
                </template>
                </b-pagination>
            </div>
            </div>
        </template>
        </vue-good-table>
            
    </b-card>

    <b-sidebar
      ref="sidebar_azioni"
      id="sidebar-right"
      bg-variant="white"
      :title="infoSideBar.titolo"
      right
      backdrop
      shadow
    >
      <div>
        <div class="py-0 px-2">
          
          <div class="divider">
              <div class="divider-text text-primary fw-bolder">DETTAGLI</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Stato:</span> 
              <b-badge v-if="infoSideBar.paid" variant="light-success">Pagato</b-badge>
              <b-badge v-else variant="light-warning">Da pagare</b-badge>
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Disputa:</span> 
              <span v-if="infoSideBar.bonificidispute !== null">
                <b-badge variant="light-info">
                  Pagato con bonifico
                </b-badge>
              </span>
              <span v-else>
                <b-badge variant="light-danger" v-if="infoSideBar.id_dispusta != null">Disputa</b-badge>
              <b-badge variant="light-success" v-else>Nessuna</b-badge>
              </span>
            </b-col>

            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Importo:</span> {{ prezzoFormattatoConIva(infoSideBar.license.price, infoSideBar.vat_scheme_id) }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Aggiornato:</span> {{ formattazioneDataOra(infoSideBar.updated_at, 'it', 'DD/MM/YY - HH:mm') }}
            </b-col>
          </b-row>

          <div v-if="infoSideBar.bonificidispute !== null">
            <div class="divider">
                <div class="divider-text text-primary fw-bolder">BONIFICO</div>
            </div>

            <b-row cols="1">
              <b-col class="riga_sidebar">
                <span class="font-weight-bold spacer-dettagli">Importo:</span> {{ prezzoFormattatoConIva(infoSideBar.bonificidispute.importo, 0) }}
              </b-col>
              <b-col class="riga_sidebar" v-if="infoSideBar.bonificidispute !== null">
                <span class="font-weight-bold spacer-dettagli">Data:</span> {{ formattazioneDataOra(infoSideBar.bonificidispute.data_esecuzione, 'it', 'DD/MM/YY') }}
              </b-col>
            </b-row>

          </div>

          <div class="divider">
            <div class="divider-text text-primary fw-bolder mt-0">STRIPE</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Metodo:</span> {{ infoSideBar.payment_method }}
            </b-col>
            <b-col class="riga_sidebar" v-if="infoSideBar.api_payment_intent">
              <span class="font-weight-bold spacer-dettagli">Payment:</span> <a :href="infoSideBar.link_api_payment_intent" target="_blank">Apri payment</a>
            </b-col>
            <b-col class="riga_sidebar" v-if="infoSideBar.api_invoice">
              <span class="font-weight-bold spacer-dettagli">Invoice:</span> <a :href="infoSideBar.link_api_invoice" target="_blank">Apri invoice</a>
            </b-col>
          </b-row>

          <div class="divider">
              <div class="divider-text text-primary fw-bolder">LICENZA</div>
          </div>
          <b-row cols="1">
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">ID:</span> {{ infoSideBar.license.ref_code }}
            </b-col>
            <b-col class="riga_sidebar">
              <span class="font-weight-bold spacer-dettagli">Tipo:</span> <b-badge :variant="statusVariantTipo(infoSideBar.license.type)">{{ infoSideBar.license.type }}</b-badge>
            </b-col>
          </b-row>

          <div v-if="infoSideBar.bonificidispute === null">
            <div v-if="infoSideBar.refund">
              <div class="divider">
                <div class="divider-text text-primary fw-bolder mt-0">RIMBORSATO</div>
              </div>
              <b-row cols="1">
                <b-col class="riga_sidebar">
                  <span class="font-weight-bold spacer-dettagli">Stato:</span> 
                  <b-badge style="margin-left:10px;" :variant="getBadgeStatoRimborso(infoSideBar.refund)">
                    {{ statoRimborso(infoSideBar.refund) }}
                  </b-badge>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <div v-if="((infoSideBar.paid === true) || (infoSideBar.id_dispusta != null))">
                <div class="divider">
                  <div class="divider-text text-primary fw-bolder mt-0">AZIONI</div>
                </div>

                <div v-if="((infoSideBar.paid === true) && (infoSideBar.id_dispusta != null))">
                  <b-row>
                    <b-col md="12" lg="6">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-danger" block
                        class="mb-1"
                        v-if="(infoSideBar.paid === true)"
                        @click="faiRimborso(infoSideBar.id,prezzoFormattatoConIva(infoSideBar.license.price, infoSideBar.vat_scheme_id))"
                      >
                        <feather-icon icon="SendIcon" /> Invio rimborso
                      </b-button>
                    </b-col>
                    <b-col md="12" lg="6">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-info" block
                        class="mb-1"
                        v-if="(infoSideBar.id_dispusta != null)"
                        @click="registraBonifico(infoSideBar.id,prezzoFormattatoConIva(infoSideBar.license.price, infoSideBar.vat_scheme_id), infoSideBar.id_dispusta.id)"
                      >
                        <feather-icon icon="ClipboardIcon" /> Registra bonifico
                      </b-button>
                    </b-col>

                  </b-row>
                </div>

                <div v-else>
                  <p class="pb-1">
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-danger" block
                      class="mb-1"
                      v-if="(infoSideBar.paid === true)"
                      @click="faiRimborso(infoSideBar.id,prezzoFormattatoConIva(infoSideBar.license.price, infoSideBar.vat_scheme_id))"
                    >
                      <feather-icon icon="SendIcon" /> Invio rimborso
                    </b-button>
                  </p>
                </div>

              </div>

            </div>

          </div>

          
        </div>

      </div>
    </b-sidebar>

    
    <b-sidebar
      ref="sidebar_registrazionebonifico"
      id="sidebar-registrabonifico"
      bg-variant="white"
      title="Registra pagamento con bonifico"
      :visible="sidebar_visibile"
      right
      backdrop
      shadow
      @hidden="sidebarChiusaRegistrazioneBonifico"
    >
    <div>
      <div class="p-2">
          <b-alert variant="info" show class="p-1">
            Importo da incassare: {{ registraBonificoModal.prezzoFormattato }}
          </b-alert>

          <validation-observer ref="registrazioneBonificoRules">
            <b-form>
              <b-form-group label="Importo *" label-for="importo">
                <validation-provider
                #default="{ errors }"
                name="Nome"
                rules="required"
                >  
                <b-form-input
                  v-model="registraBonificoModal.importo"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Data ricezione *" label-for="data_esecuzione">
                <validation-provider
                #default="{ errors }"
                name="Nome"
                rules="required"
                > 
                <flat-pickr
                  v-model="registraBonificoModal.data_esecuzione"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div class="mt-2">
                <b-button
                  variant="outline-primary"
                  type="submit"
                  @click.prevent="validationFormRegistraBonifico()"
                  >
                  Salva
                </b-button>
              </div>

            </b-form>
          </validation-observer>

        </div>
      </div>
    </b-sidebar>

  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BCardText, BRow, BCol, BBadge, BPagination, BSpinner, BFormGroup, BInputGroup, BForm, BFormInput, BInputGroupPrepend, BInputGroupAppend, BDropdownDivider, BFormSelect, BDropdown, BDropdownItem, BButton, BSidebar, VBToggle, VBTooltip, BAlert,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import { prezzoFormattatoConIva, prezzoFormattato, statoRimborso } from '@core/utils/funzioniGlobali' 
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import it from 'vee-validate/dist/locale/it.json'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BCard, 
    BCardText,
    BRow, 
    BCol, 
    BBadge,
    BPagination,
    BSpinner,
    BInputGroup,
    BFormGroup, 
    BForm, 
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BDropdownDivider,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BButton,
    BAlert, 

    ValidationProvider,
    ValidationObserver,
    localize,
    it, 
    flatPickr,
  },
  setup() {
      return {
          prezzoFormattatoConIva, 
          prezzoFormattato,  
          statoRimborso, 
      }
  },
  directives: {
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      isLoading: true,
      emptystate: true, 
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Cliente',
          field: 'license.customer.billing.company_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Licenza',
          field: 'license.ref_code',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Tipo',
          field: 'license.type',
          width: '120px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Pagato',
          field: 'paid',
          width: '100px',
          //tdClass: 'text-center',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra', 
            filterDropdownItems: [
              { text: 'Pagato', value: true },
              { text: 'In Corso', value: false }
            ],
          },
        },
        {
          label: 'Disputa',
          field: 'dispute.id',
          width: '100px',
          //tdClass: 'text-center',
          html: true,
          filterOptions: {
            enabled: false,
            placeholder: 'Filtra', 
            filterDropdownItems: [
              { text: 'Nessuna', value: null },
              { text: 'Disputa', value: '' }
            ],
          },
        },
        {
          label: 'Importo',
          field: 'license.price',
          width: '100px',
          filterOptions: {
            enabled: true,
            placeholder: 'Filtra',
          },
        },
        {
          label: 'Aggiornato',
          field: 'updated_at',
          width: '120px',
          filterOptions: {
            enabled: false,
            placeholder: 'Filtra',
          },
        },

        {
          label: '',
          field: 'azioni',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
      rows: [],
      searchTerm: '',
      resetState: 'hidden',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      startServerParams: {
        columnFilters: {},
        sort: [
            {
            field: 'id',
            type: 'desc'
            }
        ],
        page: 1, 
        perPage: 10
      },
      options_ricerca: [
        { value: null, text: 'seleziona...' },
        { value: 'billing.company_name', text: 'Ragione Sociale' },
        { value: 'user.surname', text: 'Cognome' },
        { value: 'user.email', text: 'Email' },
        { value: 'user.mobile_phone', text: 'Cellulare' },
        { value: 'rating', text: 'Rating (da 1 a 5)' },
        /* 
        { value: 'roles.name', text: 'Ruolo' },
        { value: 'billing.region.name', text: 'Regione' },
        { value: 'billing.province.name', text: 'Provincia' },
        { value: 'colonna_inesistete', text: 'Colonna Errore' },
        { value: 'mobile_phone', text: 'Cellulare', notEnabled: true, disabled: true },
        {
          label: 'Raggruppamento',
          options: [
            { value: 'altro_1', text: 'Altro 1 (non usare)' },
            { value: 'altro_2', text: 'Altro 2 (non usare)' }
          ]
        }
        */
      ],
      campiRicerca: {
        nome: '',
        sezione: null,
      },
      infoSideBar: {
        id: '',
        license: [ ],
        vat_scheme_id: '',
        payment_method: '',
        api_invoice: '',
        api_payment_intent: '',
        paid: '',
        refund: '',
        id_dispusta: null, 
        created_at: '',
        updated_at: '',
        titolo: '', 
        link_api_invoice: '', 
        link_api_payment_intent: '', 
        bonificidispute: [ ], 
      },
      listSourceOption: [ ],
      listStatusOption: [ ],
      Caricato: false,
      errore_caricamento: false,

      registraBonificoModal: {
        id_pagamento: '',
        prezzoFormattato: '',
        id_dispusta: '', 
        importo: '', 
        data_esecuzione: '',
      }, 
      registraBonificoModal_start: {
        id_pagamento: '',
        prezzoFormattato: '',
        id_dispusta: '',
        importo: '', 
        data_esecuzione: '',
      }, 
      sidebar_visibile: false,

    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        2 : 'light-success',
        1 : 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    
    statusVariantTipo() {
      const statusColor = {
        'Abbonamento' : 'light-info',
        'OneShot' : 'light-secondary',
      }

      return status => statusColor[status]
    },
  },
  mounted() {
    //in caso di resize del browser -> ricalcolo della larghezza della finestra
    window.onresize = () => {
      this.checkWindowsSizeAndResponsiveGoodTable();
    }
  },
  created() {
    this.checkWindowsSizeAndResponsiveGoodTable();
    
    //adesso faccio il caricamento dei dati
    this.loadItems();

    this.Caricato = true;
    this.errore_caricamento = false;
  },
  methods: {
    checkWindowsSizeAndResponsiveGoodTable(){
      if(window.innerWidth <768){
        this.$set(this.columns[1], 'hidden', true)
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', true)
        this.$set(this.columns[4], 'hidden', true)
        this.$set(this.columns[6], 'hidden', true)
      } else if(window.innerWidth <1000){
        this.$set(this.columns[1], 'hidden', true)
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
      } else if(window.innerWidth <1200){
        this.$set(this.columns[1], 'hidden', false)
        this.$set(this.columns[2], 'hidden', true)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
      } else if(window.innerWidth <1400){
        this.$set(this.columns[1], 'hidden', false)
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
      } else {
        //tutte le colonne visualizzate
        this.$set(this.columns[1], 'hidden', false)
        this.$set(this.columns[2], 'hidden', false)
        this.$set(this.columns[3], 'hidden', false)
        this.$set(this.columns[4], 'hidden', false)
        this.$set(this.columns[6], 'hidden', false)
      }
    },
    formattazioneDataOra(converted_at,lang,formato) {
      if (converted_at) {
        return moment(String(converted_at)).locale(lang).format(formato)
      } else {
        return '---'
      }
    },
    ricercaGenerale(){
      //console.log("ricerca generale - chiamata Api per avere la ricerca su tutti i dati e NON solo sui dati dell'attuale viewport della tabella ;-)")
      console.log(this.campiRicerca)

      if((this.campiRicerca.sezione !== null) && (this.campiRicerca.sezione !== 'undefined')){
        console.log("ok ricerca valida")

        //aggiorna parametri con la stessa funzione del filtro colonna ;-)
        this.updateParams({
          columnFilters: {
            [this.campiRicerca.sezione]: this.campiRicerca.nome
          },
        });

        //forza reset filtro colonne
        this.$refs.table.reset();

        this.loadItems();

        //attiva bottone "reset"
        this.resetState = 'attiva';
      }
    },
    clickReset(){
      console.log("clickReset");

      //forza reset filtro colonne
      this.$refs.table.reset();

      //forza reset parametri iniziali della tabella
      this.updateParams(this.startServerParams);
      this.loadItems();

      //reset campi ricerca
      this.campiRicerca.nome = '';
      this.campiRicerca.sezione = null;
      //disattiva bottone "reset"
      this.resetState = 'hidden';
    },
    advanceFilter(val) {
      //this.searchTerm = val

      this.updateParams(val);
      this.loadItems();
    },
    sidebarAction(id, license, api_invoice, api_payment_intent, paid, refund, created_at, updated_at, titolo, id_dispusta, bonificidispute) {
      //console.log(refund);
      //console.log(license);

      this.infoSideBar = { id: id,
        license: license,
        vat_scheme_id: license.customer.billing.vat_scheme_id,
        payment_method: license.customer.billing.payment_method,
        api_invoice: api_invoice,
        api_payment_intent: api_payment_intent,
        paid: paid,
        refund: refund,
        created_at: created_at,
        updated_at: updated_at, 
        titolo: titolo, 
        link_api_invoice: 'https://dashboard.stripe.com/test/invoices/'+api_invoice, 
        link_api_payment_intent: 'https://dashboard.stripe.com/test/payments/'+api_payment_intent, 
        updated_at: updated_at, 
        id_dispusta: id_dispusta, 
        bonificidispute: bonificidispute, 
      };

      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    
    updateParams(newProps) {
      //console.log(newProps)

      if (typeof newProps.columnFilters !== 'undefined'){
        if(typeof newProps.columnFilters.paid !== 'undefined'){
          //in caso di campo con "stringa" => vai di filtro per il valore richiesto
          if(newProps.columnFilters.paid == 'Pagato'){
            newProps.columnFilters['user.surname'] = newProps.columnFilters.aggregato_name_surname;
          }

          //in caso di campo in cui avevo impostato un filtro e lo voglio cancellare
          if(newProps.columnFilters.paid == ''){
            delete(newProps.columnFilters['user.surname']);
          }
        }

      }

      //attiva bottone "reset" filtro o ricerca
      this.resetState = 'attiva';

      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      //console.log('cambio ordinamento')
      //console.log(params)

      let field_ricerca = '';

      //colonne con relazione
      if(params[0].field == 'source.text'){
        field_ricerca = 'source.name';
      } else if(params[0].field == 'aggregato_name_surname'){
        field_ricerca = 'user.surname';
      } else {
        field_ricerca = params[0].field;
      }

      this.updateParams({
        sort: [{
          type: params[0].type,
          field: field_ricerca,
        }],
      });
      this.loadItems();
    },
    
    onColumnFilter(params) {
      //console.log("AGGIORNAMENTO FILTRO COLONNA --------")
      this.updateParams(params);
      this.loadItems();
    },

    loadItems() {
      this.isLoading = true;

      if (typeof this.serverParams.columnFilters.aggregato_name_surname !== 'undefined'){
        var temporaneo_aggregato_name_surname = this.serverParams.columnFilters.aggregato_name_surname;
        delete(this.serverParams.columnFilters.aggregato_name_surname);
      }

      this.$http.get('api/crm/license-payment-logs/list', {
        params: this.serverParams 
        }).then(response => { 
            if(response.data.statusCode == 200){
              //ok
              this.totalRecords = response.data.reply.meta.total;
              this.rows = response.data.reply.data;

              //console.log(" ui ---------------------")
              //console.log(this.rows)

              //bind colonna "aggregato_name_surname" fix
              if (temporaneo_aggregato_name_surname !== 'undefined'){
                this.serverParams.columnFilters.aggregato_name_surname = temporaneo_aggregato_name_surname;
              }
              
            } else if(response.data.statusCode == 422){
              //errori con testo di notifica ok dall'api
              this.$swal({
                title: 'Errore',
                text: 'codice errore: '+response.data.reply,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            } else {
              //tutto gli altri possibili errori
              this.$swal({
                title: 'Errore Generico',
                text: 'codice errore: '+response.data.statusCode,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  textButton: 'Chiudi',
                },
                buttonsStyling: false,
              })
            }
            
            //rimuovi il loading dopo il caricamento dei dati nella tabella
            this.isLoading = false;
        
        })

    },

    faiRimborso(id_riga,importo){
      this.$swal({
        title: 'Sei sicuro di voler procedere?',
        text: "Vuoi confermare il rimborso al cliente su Stripe di "+importo+" ?",
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'SI, Procedi',
        cancelButtonText: 'Annulla operazione',
        customClass: {
          confirmButton: 'btn btn-outline-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

            this.$http.post('api/crm/license-payment-logs/refund/'+id_riga)
            .then(response => { 
                console.log("risposta server --------")
                console.log(response.data)

                if(response.data.statusCode===200){
                  //risposta positiva
                  this.$swal({
                    icon: 'success',
                    title: 'Richiesta di rimborso presa in carico da Stripe',
                    text: 'Il riborso avverrà nel tempi e nelle modalità previste da Stripe, puoi controllare i dettagli del pannello su Stripe',
                    confirmButtonText: 'chiudi',
                    customClass: {
                    confirmButton: 'btn btn-success',
                    },
                  });
                  
                  //chiudi sidebar
                  this.$refs.sidebar_azioni.hide();

                } else {
                //risposta negativa (errore sul server)
                  this.$swal({
                    icon: 'error',
                    title: 'Si è verificato un errore',
                    text: 'operazione non riuscita, ti invitamo a verificare lo stato del pagamento su Stripe e ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                    customClass: {
                    confirmButton: 'btn btn-outline-primary',
                    },
                  })
                }
            }).catch(e => {
                console.log(e);
            })
        }
      })
    },

    getBadgeStatoRimborso(value) {
      switch (value) {
        case 'pending':
          return 'light-warning';
        case 'succeeded':
          return 'light-danger';
        default:
          return 'light-info';
      }
    },

    registraBonifico(id_pagamento,prezzoFormattato,id_dispusta){
      console.log("registra bonifico | id_pagamento: "+id_pagamento+" | prezzo: "+prezzoFormattato+" | id_dispusta: "+id_dispusta)

      this.registraBonificoModal = {
        id_pagamento: id_pagamento,
        prezzoFormattato: prezzoFormattato,
        id_dispusta: id_dispusta,
      }

      this.$root.$emit('bv::toggle::collapse', 'sidebar-registrabonifico')
    },
    sidebarChiusaRegistrazioneBonifico(){
      //azzero form (serve per l'eventuale uso di "nuovo")
      this.registraBonificoModal = this.registraBonificoModal_start
      //reset validation form
      this.$refs.registrazioneBonificoRules.reset();
      
      console.log("chiudo sidebar registrazione bonifico")
      this.$refs.sidebar_registrazionebonifico.hide();
    },
    validationFormRegistraBonifico(){
      this.$refs.registrazioneBonificoRules.validate().then(success => {
        if (success) {
          //rimuovi questi valori perchè non servono al momento del salvataggio
          delete this.registraBonificoModal.prezzoFormattato;
          delete this.registraBonificoModal.id_pagamento;
          
          console.log(this.registraBonificoModal)

          this.$http.post('api/crm/license-payment-logs/salvabonifico', 
            this.registraBonificoModal 
            ).then(response => {
              if((response.data.statusCode>=200) && (response.data.statusCode<=299)){
                //risposta positiva
                if(response.data.reply.operazione == 'save'){
                  //aggiorno lista assistenti
                  this.loadItems();

                  //chiudo finestra registrazione bonifico
                  this.sidebarChiusaRegistrazioneBonifico();

                  //chiudo finestra dettaglio bonifico
                  this.$refs.sidebar_azioni.hide();

                  this.$swal({
                      icon: 'success',
                      title: response.data.reply.reply,
                      confirmButtonText: 'chiudi',
                      customClass: {
                      confirmButton: 'btn btn-success',
                      },
                  })
                } else {
                  //questo non dovrebbe mai accadere ... ma non si sa mai -> visualizzo risposta ma non faccio redirect
                  this.$swal({
                      icon: 'warning',
                      title: 'Si è verificato un errore',
                      text: 'Salvataggio riuscito ma con errore '+response.data.statusCode+', ti preghiamo di contattate l\'assistenza tecnica per segnalare il problema',
                      customClass: {
                      confirmButton: 'btn btn-outline-primary',
                      },
                  })
                }

              } else {
                //risposta negativa (errore sul server)
                this.$swal({
                    icon: 'error',
                    title: 'Si è verificato un errore',
                    text: response.data.reply.message,
                    customClass: {
                    confirmButton: 'btn btn-outline-primary',
                    },
                })
              }
            }).catch(e => {
              console.log(e);
            });

        }
      })
    },

  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';

.riga_sidebar{
  padding-bottom: 5px;
}
.spacer-dettagli{
  width: 90px;
  display: inline-block;
}
</style>